import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect(){
    const select2Element = this.element;
    const select2Parent = select2Element.getAttribute("select2-parent");
    const allowClear = select2Element.getAttribute("select2-allow-clear") === "true";
    const placeholder = select2Element.getAttribute("select2-placeholder") || '';
    const  multiple = select2Element.getAttribute("select2-multiple") === "true";
    const select2Id = `#${select2Element.id}`;

    const options = {
        allowClear: allowClear,
        placeholder: placeholder,
        multiple: multiple
    };

    $(select2Id).unbind("onload")
    initializeSelect2Input(select2Id, select2Parent, options);
  }
}